import { Injectable, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from './api.service';
import { Utenteservice } from './utente.service';
import { nicaGridComuni, nicaGridStampaRegistri} from './templates/nicaGridComuni';

@Injectable({
  providedIn: 'root'
})
export class FormsTemplateGridService implements OnInit {
  aspect: any;
  constructor(private spinner: NgxSpinnerService, private appService: Apiservice, public utenteService: Utenteservice) {  
  }
  ngOnInit(): void {
    this.aspect = 7.7;
  }

  public getTemplateService(e: string) {
    /************************In Lavorazione******************************* */
    //console.log("SERVICEEEEEEEEEEEEEEEEEEEEEEE ", e)
    if (e == 'comune') { return nicaGridComuni }
    if (e == 'nicaGridStampaRegistri') { return nicaGridStampaRegistri }
    //nicaGridComuni
    //statisticarifiuti 
    //GiacenzeIniziali
  }
}
